import React, { useState, useEffect } from 'react';
import { Input, Button } from 'reactstrap';
import { Icon } from '@mdi/react';
import { mdiDelete } from '@mdi/js';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

import userImage1 from '../../../assets/images/yellofintunafish.png';

const BookMarkItem = ({ BookMarkdata, onDelete }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [BookMarkdata2, setBookMarkdata2] = useState(BookMarkdata);

  console.log(BookMarkdata);

  // Calculate total price whenever selectedItems or quantities change
  useEffect(() => {
    const { total, itemCount } = calculateTotal();
    const courierFee = calculateTotal();
    const Processing_Fee = calculateTotal();

    // Pass both total and count to the parent
  }, [selectedItems, quantities]);

  const handleCheckboxChange = async (isChecked, item) => {
    setQuantities((prev) => {
      const newQuantities = { ...prev, [item._id]: item.Weight };
      console.log(newQuantities); // Log the updated quantities here
      return newQuantities;
    });

    setSelectedItems((prevItems) => {
      let updatedItems = [...prevItems];

      if (isChecked) {
        // Add the item if checked
        if (!prevItems.some((BookMarkItem) => BookMarkItem.id === item._id)) {
          updatedItems = [
            ...prevItems,
            {
              id: item._id,
              BookMarkdata: {
                _id: item.stock._id,
                Stock_id: item.stock.Stock_id,
                Product_Name: item.stock.Product_Name,
                Boat_Number: item.stock.Boat_Number,
                Harbour: item.stock.Harbour,
                Price_per_Kg: item.stock.Price_per_Kg,
                Courier_id: item.stock.Courier_id,
                Courier_Method: item.stock.Courier_Method,
                Courier_Fee: item.stock.Courier_Fee,
                Processing_Plant_Id: item.stock.Processing_Plant_Id,
                Processing_Type: item.stock.Processing_Type,
                Processing_Fee: item.stock.Processing_Fee,
              },
              quantity: item.Weight, // Directly use the item's weight for quantity
              price: item.stock.Price_per_Kg,
              Processing_Fee: item.stock.Processing_Fee,
              Courier_Fee: item.stock.Courier_Fee,
            },
          ];
        }
      } else {
        // Remove the item if unchecked
        updatedItems = prevItems.filter(
          (BookMarkItem) => BookMarkItem.id !== item._id
        );
      }
      return updatedItems;
    });
  };

  const handleQuantityChange = (itemId, newQty) => {
    setQuantities((prev) => {
      const updatedQuantities = { ...prev, [itemId]: newQty };
      console.log(updatedQuantities); // Log the updated quantities here
      return updatedQuantities;
    });

    // Update selectedItems based on the updated quantities
    setSelectedItems((prevItems) => {
      return prevItems.map((item) =>
        item.id === itemId ? { ...item, quantity: newQty } : item
      );
    });
  };

  const handleDeleteItem = (itemId) => {
    // Show confirmation dialog
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.isConfirmed) {
        // If confirmed, proceed with the deletion
        onDelete(itemId);
        console.log(itemId);

        setSelectedItems((prevItems) =>
          prevItems.filter((item) => item.id !== itemId)
        );
        setBookMarkdata2((prevItems) =>
          prevItems.filter((item) => item._id !== itemId)
        );

        setQuantities((prev) => {
          const updatedQuantities = { ...prev };
          delete updatedQuantities[itemId];
          return updatedQuantities;
        });
      }
    });
  };

  const calculateTotal = () => {
    const total = selectedItems.reduce((sum, item) => {
      const quantity = quantities[item.id] || 0;
      const pricePerKg = item.price || 0;

      //const courierFee = (item.Courier_Fee || 0) * 10; // Default to 0 if undefined
      //const processingFee = (item.Processing_Fee || 0) * quantity;

      // Add courier fee and processing fee to the item's total cost
      return sum + quantity * pricePerKg; //+ courierFee + processingFee;
    }, 0);

    const courierFee = selectedItems.reduce((sum, item) => {
      //const quantity = quantities[item.id] || 0;
      //const pricePerKg = item.price || 0;

      const courierFee = item.Courier_Fee || 0; // Default to 0 if undefined
      //const processingFee = (item.Processing_Fee || 0) * quantity;

      // Add courier fee and processing fee to the item's total cost
      return sum + courierFee;
    }, 0);

    const Processing_Fee = selectedItems.reduce((sum, item) => {
      const quantity = quantities[item.id] || 0;
      //const pricePerKg = item.price || 0;

      const Processing_Fee = (item.Processing_Fee || 0) * quantity; // Default to 0 if undefined
      //const processingFee = (item.Processing_Fee || 0) * quantity;

      // Add courier fee and processing fee to the item's total cost
      return sum + Processing_Fee;
    }, 0);

    const itemCount = selectedItems.length; // Count of selected items

    return { total, itemCount, courierFee, Processing_Fee };
  };

  return (
    <div className="list-view">
      {BookMarkdata.map((item) => {
        const { stock } = item;
        return (
          <div
            key={item._id}
            className="list-item mb-3"
          >
            <div
              style={{ width: '100%' }}
              className="card list-card"
            >
              <div className="overlay-boat list-card-body card-body">
                <div className="d-flex align-items-start">
                  {/* Image and Overlay */}
                  <div
                    style={{
                      position: 'relative',
                      width: '225px',
                      height: '150px',
                    }}
                  >
                    <img
                      src={userImage1}
                      alt="Product"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '20px',
                      }}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.1)', // Overlay color
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '18px',
                        borderRadius: '20px',
                      }}
                    ></div>
                  </div>

                  {/* Checkbox */}
                  {/* <div
                    style={{ position: 'absolute', left: '10px', top: '10px' }}
                  >
                    <Input
                      type="checkbox"
                      onChange={(e) =>
                        handleCheckboxChange(e.target.checked, item)
                      }
                      checked={selectedItems.some(
                        (BookMarkItem) => BookMarkItem.id === item._id
                      )}
                      style={{ transform: 'scale(1.5)' }}
                    />
                  </div> */}

                  {/* Product Details */}
                  <div className="card-body-content flex-grow-1">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <span style={{ fontSize: '1.1rem', fontWeight: '800' }}>
                          <Link
                            to={`/stockdetails/${item.details.data._id}`}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                          >
                            {item.details.data.Product_Name}
                          </Link>
                        </span>
                        <br />
                        <span style={{ fontSize: '1rem', fontWeight: '500' }}>
                          {item.details.data.Size_Weight}kg
                        </span>
                        <br />
                        <span
                          style={{
                            fontSize: '1rem',
                            color: '#00d4ff',
                            fontWeight: '800',
                          }}
                        >
                          {item.details.data.Price_per_Kg} LKR/kg
                        </span>
                        <br />
                        <span>
                          {item.details.data.Harbour} |{' '}
                          {item.details.data.Boat_Number}
                        </span>
                      </div>

                      {/* Quantity Controls */}
                      {selectedItems.some(
                        (BookMarkItem) => BookMarkItem.id === item._id
                      ) && (
                        <div className="d-flex align-items-center">
                          <button
                            onClick={() =>
                              handleQuantityChange(
                                item._id,
                                Math.max(
                                  stock.Minimum_Order_Quantity,
                                  quantities[item._id] - 10
                                )
                              )
                            }
                            disabled={
                              quantities[item._id] <=
                              stock.Minimum_Order_Quantity
                            }
                            style={buttonStyle}
                          >
                            -
                          </button>
                          <Input
                            type="text"
                            min={stock.Minimum_Order_Quantity}
                            max={stock.Total_Available_Quantity}
                            value={
                              quantities[item._id] ||
                              stock.Minimum_Order_Quantity
                            }
                            onChange={(e) =>
                              handleQuantityChange(
                                item._id,
                                Math.max(
                                  stock.Minimum_Order_Quantity,
                                  parseInt(e.target.value) || 0
                                )
                              )
                            }
                            style={inputStyle}
                          />
                          <button
                            onClick={() =>
                              handleQuantityChange(
                                item._id,
                                Math.min(
                                  stock.Total_Available_Quantity,
                                  quantities[item._id] + 10
                                )
                              )
                            }
                            style={buttonStyle}
                          >
                            +
                          </button>
                        </div>
                      )}

                      {/* Delete Button */}
                      <Button
                        color="link"
                        onClick={() => handleDeleteItem(item._id)}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          bottom: '10px',
                        }}
                      >
                        <Icon
                          path={mdiDelete}
                          size={1}
                          color="#000"
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

// Styling
const buttonStyle = {
  width: '30px',
  height: '30px',
  textAlign: 'center',
  border: 'none',
  backgroundColor: '#f8f8f8',
  cursor: 'pointer',
};

const inputStyle = {
  width: '60px',
  height: '30px',
  textAlign: 'center',
  margin: '0 5px',
  border: '1px solid #ddd',
};

export default BookMarkItem;
